export class ExpectedError extends Error {
  constructor(msg?: string) {
    super(msg ?? "Expected error");

    Object.setPrototypeOf(this, ExpectedError.prototype);
  }
}
